import React from "react";

const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  confirmColor = "#0F2A40",
  onConfirm,
  onClose,
  confirmDisabled = false
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="jmodal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="jmodal-content"
        style={{
          width: 389,
          height: 280,
          borderRadius: 18,
          padding: "28px 32px",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center"
        }}
      >
        <div style={{ fontSize: "1.25rem", fontWeight: 700, marginBottom: 18, color: "#111827" }}>
          {title}
        </div>
        <div style={{ fontSize: "1rem", color: "#374151", marginBottom: 22, lineHeight: 1.5 }}>
          {typeof message === "string" ? message : message}
        </div>
        <button
          type="button"
          disabled={confirmDisabled}
          style={{
            width: "100%",
            border: "none",
            borderRadius: 12,
            padding: "14px 16px",
            background: confirmDisabled ? "#9ca3af" : confirmColor,
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "1rem",
            cursor: confirmDisabled ? "not-allowed" : "pointer"
          }}
          onClick={() => onConfirm?.()}
        >
          {confirmLabel}
        </button>
      </div>
    </div>
  );
};

export default ConfirmActionModal;

